<template>
  <table class="main-table">
    <thead v-if="type === 'rows'">
    <draggable
        v-if="draggable_mode"
        v-model="localHeaders"
        tag="tr"
        @change="onDragChange"
    >
      <template v-for="header in localHeaders">
        <td :key="header.key"
            class="sortable"
            @click="$emit('set-sort', header.key)"
            scope="col"
            v-if="showHeaders[header.key]"
        >
          {{ $vuetify.lang.t('$vuetify.' + header.name) }}
          <v-icon
              class="sorts__icon"
              v-if="sort.includes(header.key)"
              :class="{ reverse: sort[0] === '-' }"
          >
            mdi-arrow-up
          </v-icon>
        </td>
      </template>
    </draggable>
    <template v-else>
      <td v-if="photo"></td>
      <template v-for="header in localHeaders">
        <td :key="header.key" v-if="showHeaders[header.key]">
          {{ $vuetify.lang.t('$vuetify.' + header.name) }}
        </td>
      </template>
      <td v-if="showActions"></td>
    </template>
    </thead>
    <tbody :class="{ 'cards': type === 'cards' }">
    <!-- slot for rendering cards or rows -->
    <slot
        name="cards"
        :type="type"
        :headers="localHeaders"
        :show-headers="showHeaders"
    />
    </tbody>
  </table>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'BaseTable',
  components: {draggable},
  props: {
    type: {type: String, required: true},
    draggable_mode: {type: Boolean, default: false},
    headers: {type: Array, required: true},
    showHeaders: {type: Object, default: () => {}},
    sort: {type: [String, Array], default: () => []},
    photo: {type: Boolean, default: true},
    showActions: {type: Boolean, default: true},
  },
  emits: [
    'set-sort',
    'save-settings',
    'update:headers'
  ],
  computed: {
    localHeaders: {
      get() {
        return this.headers;
      },
      set(newVal) {
        this.$emit('update:headers', newVal);
      }
    }
  },
  methods: {
    onDragChange() {
      this.$emit('save-settings');
    }
  }
};
</script>
